import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { RemovePostsFromBoard } from '..';

export function useRemovePostsFromBoard() {
  const queryClient = useQueryClient();
  const queryKeys = useQueryKeys();

  return useMutation({
    mutationFn: ({ boardId, postIds }: { boardId: string; postIds: string[] }) =>
      RemovePostsFromBoard(boardId, { post_ids: postIds }),
    onSuccess: (_, { boardId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.board.all() });
      queryClient.invalidateQueries({ queryKey: queryKeys.board.detail(boardId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.board.postsRoot(boardId) });
    },
  });
}
